<section>
    <div #message tabindex="-1">
        <p class="headline">{{ headline }}</p>
        <p class="subhead">{{ subhead }}</p>
        <div class="spinner-wrapper">
            <div class="spinner"></div>
        </div>
    </div>
</section>
